import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const nav = useNavigate();
  return (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{ fontSize: 80, marginBottom: 16 }}>🌌</div>
      <h1 style={{ marginBottom: 12 }}>Lost in space</h1>
      <p style={{ color: 'var(--text-secondary)', marginBottom: 24 }}>
        The page you're looking for doesn't exist.
      </p>
      <button className="btn btn-primary" onClick={() => nav('/')}>Back to Dashboard</button>
    </div>
  );
}
